import { getUrl } from "@irati/utils/services/graph";
var endpoints = {
    set: function () { return getUrl() + "/3rd-party-cookie/set"; },
    check: function () { return getUrl() + "/3rd-party-cookie/check"; }
};
var CookieChecker = /** @class */ (function () {
    function CookieChecker() {
    }
    CookieChecker.prototype.are3rdPartyCookiesEnabled = function () {
        return new Promise(function (resolve) {
            var tester = document.createElement("iframe");
            tester.style.display = "none";
            tester.src = endpoints.set();
            tester.addEventListener("load", load, false);
            function load() {
                window.addEventListener("message", onMessage, false);
                tester.src = endpoints.check();
                tester.removeEventListener("load", load);
            }
            function onMessage(message) {
                document.body.removeChild(tester);
                window.removeEventListener("message", onMessage);
                resolve(message.data === "enabled");
            }
            document.body.appendChild(tester);
        });
    };
    return CookieChecker;
}());
export default new CookieChecker();
